import { Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  StyledAppIcon,
  StyledAppIconWrapper,
  StyledAppItem,
  StyledAppsList,
  StyledSelector,
  StyledSelectorText,
} from "./styles";

const AppItem = ({ app }) => {
  const navigate = useNavigate();
  const handleOnClick = () => navigate(app.path);
  return (
    <StyledAppItem onClick={handleOnClick}>
      <StyledAppIconWrapper>
        <StyledAppIcon src={app.icon} alt={app.name} />
      </StyledAppIconWrapper>
      <Typography variant="body2">{app.name}</Typography>
    </StyledAppItem>
  );
};

function AppSelector({ apps }) {
  return (
    <Container>
      <StyledSelector>
        <StyledSelectorText>
          <Typography>Select an app to continue</Typography>
        </StyledSelectorText>
        <StyledAppsList>
          {apps.map((app) => (
            <AppItem key={app.name} app={app} />
          ))}
        </StyledAppsList>
      </StyledSelector>
    </Container>
  );
}

export default AppSelector;
